import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions, mapState } from "vuex";
import { Fragment } from "vue-fragment";
import { UPDATE_BOARD_SORT, UPDATE_BOARD_FILTERS } from "@Broker/@Modules/clients/board/store/board-actions";
import { SELECTED_BOARD, SELECTED_BOARD_FILTERS, COLLABORATION_ID } from "@Broker/@Modules/clients/board/store/board-getters";
import ClientBoardFilter from "./board-filters/client-board-filter";
import ClientBoardSort from "./board-sort/client-board-sort";
import { CURRENT_USER_USERNAME } from "@Broker/@Modules/main/store/account/account-getters";
import defaultState from "@Broker/@Modules/clients/board/store/board-default-state";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "BoardsToolbar",
  components: {
    Fragment,
    ClientBoardFilter,
    ClientBoardSort
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters("BoardStore", [SELECTED_BOARD, SELECTED_BOARD_FILTERS, COLLABORATION_ID])), mapGetters("AccountStore", [CURRENT_USER_USERNAME])), mapState("ReferrerStore", ["referrers"])), mapState("AgentStore", ["agents"])), {}, {
    clientBoardFilter: {
      get() {
        return this.SELECTED_BOARD_FILTERS;
      },
      set(value) {
        this.updateBoardFilters(value);
      }
    },
    isOwner() {
      return this.SELECTED_BOARD.owner;
    },
    sortBy() {
      return this.SELECTED_BOARD.sortBy;
    },
    noActivityFirst() {
      return this.SELECTED_BOARD.noActivityFirst;
    },
    boardId() {
      return this.SELECTED_BOARD.id;
    },
    referrersValues() {
      return _Object$values(this.referrers.byId || []);
    },
    agentsValues() {
      return _Object$values(this.agents.byId || []);
    },
    sortByOrder() {
      return this.SELECTED_BOARD.sortByOrder;
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [UPDATE_BOARD_SORT, UPDATE_BOARD_FILTERS])), {}, {
    handleSortChange({
      sortBy,
      noActivityFirst,
      sortByOrder
    }) {
      this.UPDATE_BOARD_SORT({
        boardId: this.boardId,
        sortBy,
        noActivityFirst,
        sortByOrder
      });
    },
    updateBoardFilters(clientBoardFilter) {
      this.UPDATE_BOARD_FILTERS({
        boardId: this.boardId,
        clientBoardFilter,
        collaboratorId: !this.isOwner && this.COLLABORATION_ID(this.boardId, this.CURRENT_USER_USERNAME)
      });
    },
    handleResetFilter() {
      this.updateBoardFilters(defaultState.defaultFilters);
    }
  })
});